import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-watch-video',
  templateUrl: './watch-video.component.html'
})
export class WatchVideoComponent implements OnInit {
  videoTitle: string = '';
  videoLink!: SafeUrl;

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.videoTitle = params['title'] || 'Training Video';
      
      let rawLink = params['link'] || '';

      if (rawLink) {
        // Fix the S3 URL format: Browsers need %20 for spaces, not the + sign
        rawLink = rawLink.replace(/ /g, '%20').replace(/\+/g, '%20');
        
        this.videoLink = this.sanitizer.bypassSecurityTrustUrl(rawLink);
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/techsure/videos']);
  }
}